var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "across-other-cost" } }, [
    _c("p", { staticClass: "text-size-20" }, [
      _vm._v("ACROSS倉庫の商品に対する費用をご確認いただけます。")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "panel-body" },
      [
        _c("expense-detail-table", {
          ref: "acrossOtherCostTable",
          attrs: {
            url: "/Warehouse/across/expense/other-cost",
            extraUrl: [],
            method: "get",
            clientMode: false,
            columns: _vm.$options.columns,
            isSearchable: true,
            searchValue: _vm.keyword,
            paginationStorageKey: "acrossOtherCost",
            needExtraData: true
          },
          on: {
            countData: function($event) {
              _vm.countData = $event
            },
            extraData: function($event) {
              _vm.extraData = $event
            },
            keyword: _vm.onHandleSearch,
            confirmDownloadCsv: _vm.openModalConfirmDownloadCsv
          },
          scopedSlots: _vm._u([
            {
              key: "detailDate",
              fn: function(props) {
                return [
                  _c("span", [
                    _vm._v(_vm._s(_vm.formatDate(props.rowData.detailDate)))
                  ])
                ]
              }
            },
            {
              key: "detail",
              fn: function(props) {
                return [
                  _c("div", {
                    staticClass: "mr-r-5",
                    domProps: { innerHTML: _vm._s(props.rowData.detail) }
                  })
                ]
              }
            },
            {
              key: "serviceName",
              fn: function(props) {
                return [_c("span", [_vm._v(_vm._s(props.rowData.serviceName))])]
              }
            },
            {
              key: "size",
              fn: function(props) {
                return [_c("span", [_vm._v(_vm._s(props.rowData.size))])]
              }
            },
            {
              key: "quantity",
              fn: function(props) {
                return [_c("span", [_vm._v(_vm._s(props.rowData.quantity))])]
              }
            },
            {
              key: "unitCost",
              fn: function(props) {
                return [
                  _c("span", [
                    _vm._v(_vm._s(_vm.formatAmount(props.rowData.unitCost)))
                  ])
                ]
              }
            },
            {
              key: "cost",
              fn: function(props) {
                return [
                  _c("span", [
                    _vm._v(_vm._s(_vm.formatAmount(props.rowData.cost)))
                  ])
                ]
              }
            }
          ])
        }),
        _vm._v(" "),
        _vm.showModalConfirmDownloadCsv
          ? _c("modal-confirm-download-csv", {
              attrs: {
                message:
                  "費用明細（保管料等）CSVをダウンロードします。<br> よろしければ「ダウンロード」ボタンを押してください。"
              },
              on: {
                close: _vm.closeModalConfirmDownloadCsv,
                downloadCsv: _vm.handleDownloadCsv
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f394a5f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f394a5f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAcross/OtherCost.vue
// module id = null
// module chunks = 